import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SessionService } from '@core/services/session.service';
import { ModalService } from '@features/modals/services/modal.service';
@Component({
  selector: 'app-chat-header-features',
  imports: [],
  templateUrl: './chat-header-features.component.html',
  styleUrl: './chat-header-features.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ChatHeaderFeaturesComponent {
  public readonly modalService = inject(ModalService);
  public readonly sessionService = inject(SessionService);
}
